import { neftApi } from "app/config";

import { removeEmptyValue } from "utils";
import { ApiTableResponse, ApiResponse } from "models";
import { AuditDTO, AuditParams, ArchiveAuditParams } from "pages/Audit/models";

const auditApiWithTag = neftApi.enhanceEndpoints({
  addTagTypes: ["audit"],
});

const auditApiSlice = auditApiWithTag.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getAudit: builder.query<ApiTableResponse<AuditDTO>, AuditParams>({
      query: (auditParams) => ({
        url: `/audit/search`,
        method: "GET",
        params: removeEmptyValue(auditParams),
      }),
      providesTags: ["audit"],
    }),

    archiveAuditTable: builder.mutation<ApiResponse<string>, ArchiveAuditParams>({
      query: (auditParams) => ({
        url: `/audit/archive`,
        method: "PUT",
        params: removeEmptyValue(auditParams),
      }),
      invalidatesTags: ["audit"],
    }),
  }),
});

export const { useGetAuditQuery, useArchiveAuditTableMutation } = auditApiSlice;

export default auditApiSlice;
